import React from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, Alert, Button } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, Storage } from 'react-jhipster';
import { handleSendOtp, handleAddSMS, reset } from '../user.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { CHANGE_PHONE, SUCCESS, ERROR, NUMBER_OTP_FAIL } from 'app/config/constants';
import OtpInput from 'react-otp-input';
import MessageModal from 'app/shared/message/message-modal';
import { generateCaptcha } from '../../password-reset/password-reset.reducer';
import AlertMessage from 'app/view-common/AlertMessage';

export interface IAuthAddPhoneProps extends StateProps, DispatchProps {
  modalShow: boolean;
  handleClose: Function;
  showFormPhone: boolean;
  showFormOtp: Function;
  showFormPassword: Function;
}

export interface IAuthAddPhoneState {
  visible: boolean;
  color: string;
  message: string;
  otp: string;
  //showFormPhone: boolean;
  phone: string;
  showMessage: boolean;
  typeReSend: boolean;
  messageSuccess: string;
  typeMessage: string;
  captcha: string;
  showMessageError: boolean;
  messageError: string;
}

export class AuthAddPhone extends React.Component<IAuthAddPhoneProps, IAuthAddPhoneState> {
  state: IAuthAddPhoneState = {
    visible: false,
    color: 'info',
    message: '',
    otp: '',
    //showFormPhone: true,
    phone: '',
    showMessage: false,
    typeReSend: false,
    messageSuccess: '',
    typeMessage: SUCCESS,
    captcha: '',
    showMessageError: false,
    messageError: ''
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.resSendOtp !== nextProps.resSendOtp) {
      const { resSendOtp } = nextProps;

      if (resSendOtp && resSendOtp.status === SUCCESS) {
        Storage.session.remove('count');
        if (!this.state.typeReSend) {
          this.props.showFormOtp();
        }
        this.setState({
          //showFormPhone: false,
          visible: true,
          color: 'success',
          message: translate('sendOtp.messages.sendotpSuccess'),
          otp: ''
        });
      } else if (resSendOtp && resSendOtp.status === 'KEY_NOT_CORRECT') {
        let count = Storage.session.get('count') ? Storage.session.get('count') : 0;
        count = count + 1;
        Storage.session.set('count', count);
        this.setState({
          otp: '',
          showMessageError: true,
          messageError: resSendOtp.message
        });
      }
    }

    if (this.props.response !== nextProps.response) {
      const { response } = nextProps;
      if (response && response.status === 'SUCCESS') {
        Storage.session.remove('count');
        if (response.addPasswordAuth) {
          this.closeModalPhone();
          this.props.showFormPassword();
        } else {
          this.setState({
            showMessage: true,
            messageSuccess: 'Chúc mừng bạn đã thêm thành công.',
            typeMessage: SUCCESS
          });
          this.closeModalPhone();
          let timerId = setTimeout(() => {
            this.setState({
              showMessage: false
            });
          }, 2000);
        }
      } else if (response && response.status) {
        this.setState({
          visible: true,
          color: 'danger',
          message: response.message && response.message !== ERROR ? response.message : translate('register.messages.error.addfail'),
          otp: ''
        });
      }
      let timerId = setTimeout(() => {
        this.setState({
          visible: false
        });
      }, 2000);
    }
    if (this.props.responseCap !== nextProps.responseCap) {
      const { responseCap } = nextProps;
      if (responseCap.status === SUCCESS) {
        this.setState({
          captcha: responseCap.message
        });
      }
    } else {
      this.props.generateCaptcha();
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }
  componentDidMount(): void {
    this.props.generateCaptcha();
  }

  handleGetOtp = (event, values) => {
    this.setState({ phone: values.mobile.trim() });
    this.props.handleSendOtp(values.mobile.trim(), CHANGE_PHONE, values.captcha);

    //event.preventDefault();
  };

  handleReSendOtp = () => {
    this.setState({ typeReSend: true });
    this.props.handleSendOtp(this.state.phone, CHANGE_PHONE, '');
  };

  handleValidSubmit = () => {
    let count = Storage.session.get('count') ? Storage.session.get('count') : 0;
    if (count < NUMBER_OTP_FAIL) {
      if (this.state.otp) {
        this.props.handleAddSMS(this.state.otp, this.state.phone);
      } else {
        this.setState({
          visible: true,
          color: 'info',
          message: 'Bạn chưa nhập mã OTP.'
        });
        let timerId = setTimeout(() => {
          this.setState({
            visible: false
          });
        }, 3000);
      }

      //count = count + 1;
      //Storage.session.set('count', count);
    } else {
      Storage.session.remove('count');
      this.setState({
        showMessage: true,
        messageSuccess: 'Bạn đã nhập sai OTP quá 5 lần, vui lòng thao tác lại!',
        typeMessage: ERROR
      });
      this.closeModalPhone();
      let timerId = setTimeout(() => {
        this.setState({
          showMessage: false
        });
      }, 3000);
    }
  };

  onDismiss = () => {
    this.setState({ visible: false, showMessageError: false, messageError: '' });
  };

  closeModalPhone = () => {
    this.setState({ showMessageError: false, messageError: '', typeReSend: false });
    this.props.handleClose();
  };

  renderFormPhone = () => {
    return (
      <Row className="justify-content-center bodyModal">
        <Col md="12">
          <h5 className="text-center txtContent">Nhập số điện thoại</h5>
          <Alert color="danger" isOpen={this.state.showMessageError} toggle={this.onDismiss}>
            {this.state.messageError}
          </Alert>
          <AvForm id="register-form" onValidSubmit={this.handleGetOtp}>
            <AvField
              name="mobile"
              validate={{
                required: { value: true, errorMessage: translate('global.messages.validate.mobile.required') },
                number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') }
              }}
            />
            <label>{translate('global.form.code.label')}</label>
            <Row style={{ flex: 1 }}>
              <Col style={{ flex: 0.6 }}>
                <AvField
                  name="captcha"
                  label=""
                  placeholder="Nhập mã xác thực"
                  type="text"
                  validate={{
                    required: { value: true, errorMessage: 'Nhập mã xác thực' }
                  }}
                />
              </Col>

              <Col style={{ flex: 0.3 }}>
                <img style={{ height: '39px' }} src={`data:image/jpeg;base64,${this.state.captcha}`} alt="" />
              </Col>

              <Col style={{ flex: 0.1 }}>
                <img
                  // style={{ marginTop: '40px' }}
                  className=""
                  src={require('../../../../images/header/refresh.svg')}
                  onClick={this.props.generateCaptcha}
                  alt=""
                />
              </Col>
            </Row>
            <Button className="btn-register" type="submit" block>
              <Translate contentKey="register.form.button">Register</Translate>
            </Button>
          </AvForm>
        </Col>
      </Row>
    );
  };

  renderFormOTP = () => {
    let phone = this.state.phone;
    if (phone) {
      phone = phone.startsWith('84') ? phone.replace('84', '0') : phone;
      phone = phone.slice(0, 3) + '****' + phone.slice(7, phone.length);
    }
    return (
      <Row className="justify-content-center bodyModal">
        {window['inputNumber']()}
        <Col md="12">
          <h2 className="text-center font-weight-bold" id="password-title">
            <Translate contentKey="sendOtp.title">Nhập mã OTP</Translate>
          </h2>
          <h6 className="text-center txtContent font-weight-bold">
            <Translate contentKey="sendOtp.txtContent" interpolate={{ mobile: phone }}>
              Otp code has been sent via phone number: {phone}
            </Translate>
          </h6>

          <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
            {this.state.message}
          </Alert>

          <AvForm className="text-center" id="password-form" onValidSubmit={this.handleValidSubmit}>
            <p className="text-center">Nhập mã OTP</p>
            <div id="inputOtp">
              <OtpInput
                inputStyle={{
                  width: '2.5rem',
                  height: '2.5rem',
                  margin: '5px 5px',
                  fontSize: '1.5rem',
                  borderRadius: 4,
                  border: '1px solid rgba(0,0,0,0.3)'
                }}
                numInputs={6}
                onChange={otp => this.setState({ otp })}
                value={this.state.otp}
              />
            </div>

            <p className="text-center">
              Bạn chưa nhận được mã?
              <Button className="btnLink" color="link" style={{ color: '#4D9235' }} type="button" onClick={this.handleReSendOtp}>
                Gửi lại OTP
              </Button>
            </p>

            <Button className="btn-register" type="submit" block>
              <Translate contentKey="sendOtp.form.button">Confirm</Translate>
            </Button>
          </AvForm>
        </Col>
      </Row>
    );
  };

  render() {
    return (
      <div>
        <MessageModal type={this.state.typeMessage} showModal={this.state.showMessage} message={this.state.messageSuccess} />
        <Modal
          className="hide-border-bottom-modal"
          isOpen={this.props.modalShow}
          toggle={this.closeModalPhone}
          backdrop="static"
          centered={window.location === window.parent.location}
        >
          <ModalHeader toggle={this.closeModalPhone} />
          <ModalBody className="padding-modal-body">{this.props.showFormPhone ? this.renderFormPhone() : this.renderFormOTP()}</ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  resSendOtp: storeState.userInfo.resSendOtp,
  response: storeState.userInfo.responseAddSMS,
  responseCap: storeState.passwordReset.responseCaptcha
});

const mapDispatchToProps = { handleSendOtp, handleAddSMS, reset, generateCaptcha };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthAddPhone);
